import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { selectCustomer } from '@main/jobs/store/job-filter.actions';
import { setFilterFormExpanded } from '@main/assignments/store/assignment-filter.actions';

export const featureKey = 'assignment-filter';

export interface State {
  filterFormExpanded: boolean;
  selectedCustomerId: number;
}

export const initialState: State = {
  filterFormExpanded: false,
  selectedCustomerId: null,
};

const assignmentFilterReducer = createReducer(
  initialState,
  on(selectCustomer, (state, { customerId }): State => ({ ...state, selectedCustomerId: customerId })),
  on(setFilterFormExpanded, (state, { expanded }): State => ({ ...state, filterFormExpanded: expanded })),
);

export function reducer(state: State | undefined, action: Action) {
  return assignmentFilterReducer(state, action);
}

export const selectAssignmentFilterState = createFeatureSelector< State>(featureKey);
export const selectFilterFormExpanded = createSelector(selectAssignmentFilterState, (state: State) => state.filterFormExpanded);
